'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Assert = require('./utility/Assert');

var _Assert2 = _interopRequireDefault(_Assert);

var _Extension = require('./Extension');

var _Extension2 = _interopRequireDefault(_Extension);

var _Framework = require('./core/Framework');

var _Framework2 = _interopRequireDefault(_Framework);

var _EventManager = require('./core/EventManager');

var _EventManager2 = _interopRequireDefault(_EventManager);

var _ServiceManager = require('./service/ServiceManager');

var _ServiceManager2 = _interopRequireDefault(_ServiceManager);

var _ServiceRegistry = require('./ServiceRegistry');

var _ServiceRegistry2 = _interopRequireDefault(_ServiceRegistry);

var _Plugin = require('./Plugin');

var _Plugin2 = _interopRequireDefault(_Plugin);

var _path = require('path');

var _path2 = _interopRequireDefault(_path);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 插件上下文，用户经常需要与该类交互，通过该类获取插件实例、服务、扩展、事件等
 * 
 * @export
 * @class PluginContext
 */
var PluginContext = function () {

    /**
     * 创建一个插件上下文
     * 
     * @ignore
     * @param {Framework} framework 
     * @param {Plugin} plugin 
     * @memberof PluginContext
     */
    function PluginContext(framework, plugin) {
        (0, _classCallCheck3.default)(this, PluginContext);

        _Assert2.default.notNull('framework', framework);
        _Assert2.default.notNull('plugin', plugin);

        this._framework = framework;
        this._plugin = plugin;

        this.frameworkStateChangedListeners = new _set2.default();
        this.pluginStateChangedListeners = new _set2.default();
        this.serviceChangedListeners = new _set2.default();
        this.extensionChangedListeners = new _set2.default();

        this.dispose = this.dispose.bind(this);
        this.start = this.start.bind(this);
        this.stop = this.stop.bind(this);

        this.getPlugin = this.getPlugin.bind(this);
        this.getPlugins = this.getPlugins.bind(this);

        this.addService = this.addService.bind(this);
        this.removeService = this.removeService.bind(this);
        this.getServices = this.getServices.bind(this);
        this.getDefaultService = this.getDefaultService.bind(this);

        this.addExtension = this.addExtension.bind(this);
        this.removeExtension = this.removeExtension.bind(this);
        this.getExtensions = this.getExtensions.bind(this);

        this.installPlugin = this.installPlugin.bind(this);

        this.addPluginStateChangedListener = this.addPluginStateChangedListener.bind(this);
        this.removePluginStateChangedListener = this.removePluginStateChangedListener.bind(this);

        this.addFrameworkStateChangedListener = this.addFrameworkStateChangedListener.bind(this);
        this.removeFrameworkStateChangedListener = this.removeFrameworkStateChangedListener.bind(this);

        this.addServiceChangedListener = this.addServiceChangedListener.bind(this);
        this.removeServiceChangedListener = this.removeServiceChangedListener.bind(this);

        this.addExtensionChangedListener = this.addExtensionChangedListener.bind(this);
        this.removeExtensionChangedListener = this.removeExtensionChangedListener.bind(this);
    }

    /**
     * 获取关联的插件
     * 
     * @type {Plugin}
     * @readonly
     * @memberof PluginContext
     */


    (0, _createClass3.default)(PluginContext, [{
        key: 'dispose',


        /**
         * 清理资源
         * 
         * @memberof PluginContext
         */
        value: function dispose() {
            this.frameworkStateChangedListeners.clear();
            this.pluginStateChangedListeners.clear();
            this.serviceChangedListeners.clear();
            this.extensionChangedListeners.clear();
        }

        /**
         * 获取插件实例
         * 
         * @param {string} id 插件id
         * @returns {Plugin} 返回指定id的插件
         * @memberof Minima
         */

    }, {
        key: 'getPlugin',
        value: function getPlugin(id) {
            return this._framework.pluginInstaller.getPlugin(id);
        }

        /**
         * 获取所有插件
         * 
         * @returns {Map.<string, Plugin>} 插件Map
         * @memberof Minima
         */

    }, {
        key: 'getPlugins',
        value: function getPlugins() {
            return this._framework.pluginInstaller.getPlugins();
        }

        /**
         * 注册服务
         * 
         * @param {string} serviceName 服务名称
         * @param {Object} serviceInstance 服务实例
         * @param {Object} [properties={}] 服务属性，默认会设置相应的插件id、name、version
         * @returns {ServiceRegistry} 返回服务注册表
         * @memberof PluginContext
         */

    }, {
        key: 'addService',
        value: function addService(serviceName, serviceInstance) {
            var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            if (!properties.pluginId) {
                properties.pluginId = this.id;
                properties.pluginName = this.plugin.name;
                properties.pluginVersion = this.plugin.version;
                properties.global = false;
            }
            return this._framework.serviceManager.add(serviceName, serviceInstance, this.plugin, properties);
        }

        /**
         * 卸载服务
         * 
         * @param {ServiceRegistry} serviceRegistry 服务注册表
         * @memberof PluginContext
         */

    }, {
        key: 'removeService',
        value: function removeService(serviceRegistry) {
            this._framework.serviceManager.remove(serviceRegistry);
        }

        /**
         * 获取服务，注意返回的服务不应该没有properties
         * 
         * @param {string} name 服务名称
         * @param {Object} properties 服务属性过滤 
         * @returns {ServiceRegistry[]} 服务对象集合
         * @memberof PluginContext
         */

    }, {
        key: 'getServices',
        value: function getServices(name, properties) {
            return this._framework.serviceManager.findServices(name, properties);
        }

        /**
         * 获取一个默认服务
         * 
         * @param {string} name 服务名称
         * @param {Object} properties 服务属性过滤 ß
         * @returns {Object} 服务对象
         * @memberof PluginContext
         */

    }, {
        key: 'getDefaultService',
        value: function getDefaultService(name, properties) {
            return this._framework.serviceManager.findDefaultService(name, properties);
        }

        /**
         * 注册扩展
         * 
         * @param {Extension} extension 扩展实例
         * @memberof PluginContext
         */

    }, {
        key: 'addExtension',
        value: function addExtension(extension) {
            this._framework.extensionManager.add(extension);
        }

        /**
         * 获取扩展集合
         * 
         * @param {string} id 
         * @returns {Set.<Extension>} 返回匹配的扩展集合
         * @memberof PluginContext
         */

    }, {
        key: 'getExtensions',
        value: function getExtensions(id) {
            return this._framework.extensionManager.find(id);
        }

        /**
         * 删除扩展对象
         * 
         * @param {Extension} extension 扩展实例
         * @memberof PluginContext
         */

    }, {
        key: 'removeExtension',
        value: function removeExtension(extension) {
            this._framework.extensionManager.remove(extension);
        }

        /**
         * 安装一个插件
         * 
         * @param {string} pluginDirectory 插件目录
         * @returns {Plugin} 插件实例
         * @memberof PluginContext
         */

    }, {
        key: 'installPlugin',
        value: function installPlugin(pluginDirectory) {
            return this._framework.pluginInstaller.installPlugin(pluginDirectory);
        }

        /**
         * 添加框架状态监听器
         * 
         * @param {function} listener 监听器函数
         * @example 
         * frameworkStateChangedListener(framework, previousState, currentState) {
         *     // ...
         * }
         * @memberof PluginContext
         */

    }, {
        key: 'addFrameworkStateChangedListener',
        value: function addFrameworkStateChangedListener(listener) {
            this.frameworkStateChangedListeners.add(listener);
            this._framework.eventManager.addFrameworkStateChangedListener(listener);
        }

        /**
         * 删除框架状态监听器
         * 
         * @param {function} listener 监听器函数
         * @memberof PluginContext
         */

    }, {
        key: 'removeFrameworkStateChangedListener',
        value: function removeFrameworkStateChangedListener(listener) {
            this.frameworkStateChangedListeners.delete(listener);
            this._framework.eventManager.removeFrameworkStateChangedListener(listener);
        }

        /**
         * 添加插件状态监听器
         * 
         * @param {function} listener 监听器函数
         * @example
         * pluginStateChangedListener(id, previous, current) {
         *     // ...
         * }
         * @memberof PluginContext
         */

    }, {
        key: 'addPluginStateChangedListener',
        value: function addPluginStateChangedListener(listener) {
            this.pluginStateChangedListeners.add(listener);
            this._framework.eventManager.addPluginStateChangedListener(listener);
        }

        /**
         * 删除插件状态监听器
         * 
         * @param {function} listener 监听器函数
         * @memberof PluginContext
         */

    }, {
        key: 'removePluginStateChangedListener',
        value: function removePluginStateChangedListener(listener) {
            this.pluginStateChangedListeners.delete(listener);
            this._framework.eventManager.removePluginStateChangedListener(listener);
        }

        /**
         * 添加服务变更监听器
         * 
         * @param {function} listener 监听器函数
         * @example 
         * serviceChangedListener(name, action) {
         * }
         * @memberof PluginContext
         */

    }, {
        key: 'addServiceChangedListener',
        value: function addServiceChangedListener(listener) {
            this.serviceChangedListeners.add(listener);
            this._framework.eventManager.addServiceChangedListener(listener);
        }

        /**
         * 删除服务变更监听器
         * 
         * @param {function} listener 监听器函数
         * @memberof PluginContext
         */

    }, {
        key: 'removeServiceChangedListener',
        value: function removeServiceChangedListener(listener) {
            this.serviceChangedListeners.delete(listener);
            this._framework.eventManager.removeServiceChangedListener(listener);
        }

        /**
         * 添加扩展变更监听器
         * 
         * @param {function} listener 监听器函数
         * @example
         * extensionChangedListener(extension, action) {
         *     // ......
         * }
         * @memberof PluginContext
         */

    }, {
        key: 'addExtensionChangedListener',
        value: function addExtensionChangedListener(listener) {
            this.extensionChangedListeners.add(listener);
            this._framework.eventManager.addExtensionChangedListener(listener);
        }

        /**
         * 删除扩展变更监听器
         * 
         * @param {function} listener 监听器函数
         * @memberof PluginContext
         */

    }, {
        key: 'removeExtensionChangedListener',
        value: function removeExtensionChangedListener(listener) {
            this.extensionChangedListeners.delete(listener);
            this._framework.eventManager.removeExtensionChangedListener(listener);
        }

        /**
         * 启动上下文
         * 
         * @memberof PluginContext
         */

    }, {
        key: 'start',
        value: function start() {
            // 注册服务、扩展
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.plugin.pluginConfiguration.services), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var service = _step.value;

                    var name = service.name;
                    var serviceClass = require(_path2.default.join(this.plugin.pluginDirectory, service.service)).default;
                    var serviceInstance = new serviceClass();

                    this.addService(name, serviceInstance, service.properties);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(this.plugin.pluginConfiguration.extensions), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var extensionData = _step2.value;

                    var extension = new _Extension2.default(extensionData.id, extensionData.data);
                    extension.owner = this.plugin;
                    this.addExtension(extension);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }

        /**
         * 停止上下文
         * 
         * @memberof PluginContext
         */

    }, {
        key: 'stop',
        value: function stop() {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = (0, _getIterator3.default)(this.pluginStateChangedListeners), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var listener = _step3.value;

                    this.removePluginStateChangedListener(listener);
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = (0, _getIterator3.default)(this.serviceChangedListeners), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var _listener = _step4.value;

                    this.removeServiceChangedListener(_listener);
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = (0, _getIterator3.default)(this.extensionChangedListeners), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var _listener2 = _step5.value;

                    this.removeExtensionChangedListener(_listener2);
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = (0, _getIterator3.default)(this.frameworkStateChangedListeners), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var _listener3 = _step6.value;

                    this.removeFrameworkStateChangeListener(_listener3);
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }

            this._framework.extensionManager.removeByOwner(this._plugin);
            this._framework.serviceManager.removeByOwner(this._plugin);
        }
    }, {
        key: 'plugin',
        get: function get() {
            return this._plugin;
        }
    }]);
    return PluginContext;
}();

exports.default = PluginContext;
//# sourceMappingURL=PluginContext.js.map